/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BiomarkerOcrRequestResponseDto } from './BiomarkerOcrRequestResponseDto';
import {
    BiomarkerOcrRequestResponseDtoFromJSON,
    BiomarkerOcrRequestResponseDtoFromJSONTyped,
    BiomarkerOcrRequestResponseDtoToJSON,
    BiomarkerOcrRequestResponseDtoToJSONTyped,
} from './BiomarkerOcrRequestResponseDto';

/**
 * 
 * @export
 * @interface BiomarkerOcrRequestsListResponseDto
 */
export interface BiomarkerOcrRequestsListResponseDto {
    /**
     * List of biomarker OCR requests
     * @type {Array<BiomarkerOcrRequestResponseDto>}
     * @memberof BiomarkerOcrRequestsListResponseDto
     */
    data: Array<BiomarkerOcrRequestResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof BiomarkerOcrRequestsListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the BiomarkerOcrRequestsListResponseDto interface.
 */
export function instanceOfBiomarkerOcrRequestsListResponseDto(value: object): value is BiomarkerOcrRequestsListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function BiomarkerOcrRequestsListResponseDtoFromJSON(json: any): BiomarkerOcrRequestsListResponseDto {
    return BiomarkerOcrRequestsListResponseDtoFromJSONTyped(json, false);
}

export function BiomarkerOcrRequestsListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiomarkerOcrRequestsListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BiomarkerOcrRequestResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function BiomarkerOcrRequestsListResponseDtoToJSON(json: any): BiomarkerOcrRequestsListResponseDto {
    return BiomarkerOcrRequestsListResponseDtoToJSONTyped(json, false);
}

export function BiomarkerOcrRequestsListResponseDtoToJSONTyped(value?: BiomarkerOcrRequestsListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BiomarkerOcrRequestResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

